<template>
    <mounting-portal mount-to="#portalvue-latest-popular-weekly-component">
        <div class="container mx-auto overflow-hidden mb-60px">
            <nav class="w-full mb-5 text-waheed text-27px text-black-two xl:mx-4">
                <button 
                    v-on:click="loadArticles('latest')"
                    :class="cssLatestLink"
                    :disabled="'latest' === type">އެންމެފަސް</button>
                <button 
                    v-on:click="loadArticles('popular')"
                    :class="cssPopularLink"
                    :disabled="'popular' === type">މަގްބޫލް</button>
                <button 
                    v-on:click="loadArticles('weekly')"
                    :class="cssWeeklyLink"
                    :disabled="'weekly' === type">7 ދުވަސް</button>
            </nav>

            <div v-if="articles.length > 0"
                class="sm:mx-4 xl:-mx-4 overflow-hidden">
                <div class="flex flex-row-reverse flex-wrap sm:-mx-4 xl:mx-0 -my-4 text-center">
                    <div v-for="(article, articleIndex) in articles"
                        :key="articleIndex"
                        class="flex flex-row-reverse w-full p-4 border-t border-l border-dashed sm:w-1/2 xl:w-1/3 border-pale-grey">
                        <featured-media-component
                            :media="article.featured_media"
                            :link="article.link"
                            :short-headline="article.short_headline"
                            class="flex-shrink-0 w-116px h-116px sm:w-170px" />

                        <div class="flex-1 flex flex-col text-right justify-between pt-2 pr-4">
                            <a :href="article.link" 
                                :title="article.short_headline"
                                class="w-full h-full flex flex-col justify-between">

                                <p class="leading-10 text-waheed text-xl lg:text-17px text-black-two hover:underline">
                                    {{ article.short_headline }}
                                </p>

                                <article-meta-component 
                                    :article="article" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="true === isLoading"
                class="sm:mx-4 xl:-mx-4 overflow-hidden mt-6">
                <article-loading-component />
            </div>

            <div v-if="hasMoreToLoad" 
                class="flex justify-center mt-30px">
                <img
                    class="cursor-pointer"
                    v-on:click="loadArticles(type)"
                    :src="CDN_GET('assets/mhr/icons/icon-listing-more.svg')"
                    alt="icon load more" />
            </div>
        </div>
    </mounting-portal>
</template>

<script>
import axios from 'axios'
import ArticleLoadingComponent from '../Loading/ArticleLoadingComponent.vue'
import FeaturedMediaComponent from '../Layout/FeaturedMedia/FeaturedMediaComponent.vue'
import ArticleMetaComponent from '../Layout/ArticleMetaComponent.vue'

export default {
    props: {
        section: {
            type: String,
            default: null
        },
        mode: {
            type: String,
            default: 'default'
        }
    },
    data() {
        return {
            type: 'latest',
            articles: [],
            cursor: null,
            isLoading: true,
            titleCSS: 'focus:outline-none latest cursor-pointer',
        }
    },
    components: {
        ArticleLoadingComponent,
        ArticleMetaComponent,
        FeaturedMediaComponent
    },
    computed: {
        hasMoreToLoad() {
            return false === this.isLoading && 
                null !== this.cursor
        },
        cssLatestLink() {
            let style = 'latest-trending-popular-titles'
            if ('sonee' === this.mode) {
                style = 'sonee-latest-trending-popular-titles'
            }

            let isActive = 'latest' === this.type ? 'active' : ''
            
            return `${this.titleCSS} ${style} ${isActive}`
        },
        cssPopularLink() {
             let style = 'latest-trending-popular-titles'
            if ('sonee' === this.mode) {
                style = 'sonee-latest-trending-popular-titles'
            }

            let isActive = 'popular' === this.type ? 'active' : ''
            
            return `${this.titleCSS} ${style} ${isActive}`
        },
        cssWeeklyLink() {
             let style = 'latest-trending-popular-titles'
            if ('sonee' === this.mode) {
                style = 'sonee-latest-trending-popular-titles'
            }

            let isActive = 'weekly' === this.type ? 'active' : ''
            
            return `${this.titleCSS} ${style} ${isActive}`
        }
    },
    methods: {
        loadArticles(type) {
            this.isLoading = true
            
            if (type !== this.type) {
                this.articles = []
                this.cursor = null
            }
            this.type = type

            let uri = 'home/latest-popular-weekly' +
                '?type=' + this.type +
                '&cursor=' + this.cursor 
            
            if (null !== this.section) {
                uri += '&section=' + this.section
            }

            axios.get(uri)
                .then(resp => {
                    const response = resp.data

                    if (response.data.length > 0) {
                        this.articles.push(...response.data)
                        this.cursor = response.cursor
                    }
                    
                    this.isLoading = false
                })
                .catch(e => {
                    console.error('LatestPopularWeeklyComponent.vue')
                    console.error(e)
                })
                .then(resp => {
                    this.isLoading = false
                });
        }
    },
    mounted() {
        this.loadArticles('latest')
    }
}
</script>